
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.995 12.586h15.043v-3.16H4.995v3.16zm4.398 2h3.11v-.659h-3.11v.66zm-2.842 0h2.386v-.659H6.553v.66zm.002 1.046h6.404v-.66H6.552v.66zm13.51-8.479H4.938a.773.773 0 00-.773.774v9.146c0 .427.346.773.772.773h15.125a.773.773 0 00.773-.773V7.927a.773.773 0 00-.773-.773z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    